import React from 'react'
import { css } from 'glamor'

import { colors, settings } from '@dooer/react-ui-kit'

import { ReactComponent as IconBookWithStar } from './assets/icon-book-with-star.svg'
import { ReactComponent as IconFilm } from './assets/icon-film.svg'
import { ReactComponent as IconBinders } from './assets/icon-binders.svg'
import { ReactComponent as IconTransaction } from './assets/icon-transaction.svg'
import { ReactComponent as IconDocument } from './assets/icon-document.svg'
import { ReactComponent as IconEmployeeBadge } from './assets/icon-employee-badge.svg'
import { ReactComponent as IconCogs } from './assets/icon-cogs.svg'
import { ReactComponent as IconTextVideo } from './assets/icon-article-text-video.svg'
import { ReactComponent as IconText } from './assets/icon-article-text.svg'
import { ReactComponent as IconAcademy } from './assets/icon-dooer-academy.svg'

export const iconStyles = {
  default: {
    position: 'relative',
    width: '20px',
    height: '20px',
    borderRadius: settings.borderRadiuses.regular,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: 'none',
    background: `transparent`,
    color: `${colors.accents.secondary}`,
  },
  brand: {
    position: 'relative',
    width: '20px',
    height: '20px',
    borderRadius: settings.borderRadiuses.regular,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: 'none',
    background: `transparent`,
    color: `${colors.accents.brand}`,
  },
  header: {
    width: 40,
    height: 40,
    borderRadius: settings.borderRadiuses.regular,
    color: `${colors.ui.light}`,
  },
}

const categoryToIconMapping = {
  bookWithStar: IconBookWithStar,
  film: IconFilm,
  binders: IconBinders,
  transaction: IconTransaction,
  document: IconDocument,
  employeeBadge: IconEmployeeBadge,
  cogs: IconCogs,
  textVideo: IconTextVideo,
  text: IconText,
  academy: IconAcademy,
}

interface IAcademyCategoryIconProps {
  category?: {
    icon?: keyof typeof categoryToIconMapping | null
  }
  iconStyle?: keyof typeof iconStyles
}

const AcademyCategoryIcon = (props: IAcademyCategoryIconProps) => {
  const Icon = props.category && props.category.icon ? categoryToIconMapping[props.category.icon] : IconFilm

  return (
    <i {...css(iconStyles.default, props.iconStyle ? iconStyles[props.iconStyle] : undefined)}>
      <Icon />
    </i>
  )
}

export default AcademyCategoryIcon
